var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{on:{"click":_vm.open_in_new_tab}},[_c('img',{attrs:{"alt":_vm.prop_image_alt_text,"src":_vm.prop_image_url_size_small}})])}
var staticRenderFns = []

export { render, staticRenderFns }